module.exports = {
  messages: {
    CN: {
      // Save Success Modal
      CampaignPublishedSuccessfully: "活动发布成功！",
      AddedToExecutionQueue: "已被添加到执行队列。",
      ExecutionForecast: "执行预测",
      QueuePosition: "队列位置",
      outOf: "共",
      Campaigns: "个活动",
      AllocationMode: "分配模式",
      SequentialExecution: "顺序执行",
      EqualDistribution: "平均分配",
      DailyLimit: "每日限额",
      requestsPerDay: "请求/天",
      CurrentExecutionQueue: "当前执行队列",
      needed: "待完成",
      today: "今日",
      Done: "已完成",
      InProgress: "进行中",
      Waiting: "等待中",
      SequentialExecutionNotice: "顺序执行通知",
      SequentialNoticeModalContent:
        "在此模式下，只有队列 #1 正在积极运行。活动 #2 和 #3 正在排队等待，直到前一个活动完成才会开始。如果活动 #1 有很多联系人，等待时间可能是几天甚至几周。",
      SequentialNoticeModalTip:
        "提示：拖动活动以重新排序优先级，或切换到「平均分配」以同时运行所有活动。",
      GoToManageCampaignList: "前往管理活动列表",
      ModifySequenceNote: "*要修改活动顺序，点击此按钮访问活动列表并进行更改。",
      EqualExecutionNotice: "平均分配通知",
      EqualNoticeContent:
        "在此模式下，所有活动将同时运行，每日限额将在它们之间平均分配。",
      ModifyAllocationNote:
        "*要修改分配模式，点击此按钮访问活动列表并进行更改。",
      done: "已完成",
      inProgress: "进行中",
      waiting: "等待中",
    },

    US: {
      // Save Success Modal
      CampaignPublishedSuccessfully: "Campaign Published Successfully!",
      AddedToExecutionQueue: "has been added to the execution queue.",
      ExecutionForecast: "Execution Forecast",
      QueuePosition: "Queue Position",
      outOf: "out of",
      Campaigns: "Campaigns",
      AllocationMode: "Allocation Mode",
      SequentialExecution: "Sequential Execution",
      EqualDistribution: "Equal Distribution",
      DailyLimit: "Daily Limit",
      requestsPerDay: "requests / day",
      CurrentExecutionQueue: "Current Execution Queue",
      needed: "needed",
      today: "today",
      Done: "Done",
      InProgress: "In Progress",
      Waiting: "Waiting",
      SequentialExecutionNotice: "Sequential Execution Notice",
      SequentialNoticeModalContent:
        "In this mode, only Queue #1 is actively running. Campaigns #2 and #3 are waiting in line and will not start until the previous campaign completes. If Campaign #1 has many contacts, the waiting time could be days or even weeks.",
      SequentialNoticeModalTip:
        "Tip: Drag campaigns to reorder priority, or switch to 'Equal Distribution' to run all campaigns simultaneously.",
      GoToManageCampaignList: "Go to Manage Campaign List",
      ModifySequenceNote:
        "*To modify the sequence of campaigns, click this button to access the campaign list and make changes.",
      EqualExecutionNotice: "Equal Execution Notice",
      EqualNoticeContent:
        "In this mode, all campaigns will run simultaneously, with daily limits distributed evenly across them.",
      ModifyAllocationNote:
        "*To modify the allocation mode, click this button to access the campaign list and make changes.",
      done: "Done",
      inProgress: "In Progress",
      waiting: "Waiting",
    },

    AR: {
      // Save Success Modal
      CampaignPublishedSuccessfully: "تم نشر الحملة بنجاح!",
      AddedToExecutionQueue: "تمت إضافتها إلى قائمة انتظار التنفيذ.",
      ExecutionForecast: "توقع التنفيذ",
      QueuePosition: "موقع قائمة الانتظار",
      outOf: "من أصل",
      Campaigns: "حملات",
      AllocationMode: "وضع التخصيص",
      SequentialExecution: "التنفيذ التسلسلي",
      EqualDistribution: "التوزيع المتساوي",
      DailyLimit: "الحد اليومي",
      requestsPerDay: "طلب / يوم",
      CurrentExecutionQueue: "قائمة انتظار التنفيذ الحالية",
      needed: "مطلوب",
      today: "اليوم",
      Done: "تم",
      InProgress: "قيد التقدم",
      Waiting: "في الانتظار",
      SequentialExecutionNotice: "إشعار التنفيذ التسلسلي",
      SequentialNoticeModalContent:
        "في هذا الوضع، فقط قائمة الانتظار #1 تعمل بنشاط. الحملات #2 و #3 في انتظار قائمة الانتظار ولن تبدأ حتى تكتمل الحملة السابقة. إذا كانت الحملة #1 تحتوي على العديد من جهات الاتصال، فقد يكون وقت الانتظار أيامًا أو حتى أسابيع.",
      SequentialNoticeModalTip:
        "نصيحة: اسحب الحملات لإعادة ترتيب الأولوية، أو قم بالتبديل إلى 'التوزيع المتساوي' لتشغيل جميع الحملات في نفس الوقت.",
      GoToManageCampaignList: "انتقل إلى إدارة قائمة الحملات",
      ModifySequenceNote:
        "*لتعديل تسلسل الحملات، انقر فوق هذا الزر للوصول إلى قائمة الحملات وإجراء التغييرات.",
      EqualExecutionNotice: "إشعار التنفيذ المتساوي",
      EqualNoticeContent:
        "في هذا الوضع، ستعمل جميع الحملات في نفس الوقت، مع توزيع الحدود اليومية بالتساوي بينها.",
      ModifyAllocationNote:
        "*لتعديل وضع التخصيص، انقر فوق هذا الزر للوصول إلى قائمة الحملات وإجراء التغييرات.",
      done: "تم",
      inProgress: "قيد التقدم",
      waiting: "في الانتظار",
    },
  },
};
